import { render, staticRenderFns } from "./person-mobile-header.vue?vue&type=template&id=0a6e4514&lang=pug&"
import script from "./person-mobile-header.vue?vue&type=script&lang=js&"
export * from "./person-mobile-header.vue?vue&type=script&lang=js&"
import style0 from "./person-mobile-header.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports